const data = `// Try editing the data, results will update when you click Save
// TIP: Changing the last number on the first data row can change the election results!

A,B,C,D,E
0,0,5,3,2
4,0,3,2,3
0,0,0,1,3
2,0,0,4,3
1,5,0,5,3
1,2,3,4,3
5,4,3,2,3
`;

export default data;
